export type PendingMemberPaymentActionState = {
  canApplyPayment: boolean;
  canSendPaymentRequest: boolean;
};

export const getPendingMemberPaymentAmountInCents = ({
  amountDueInCents,
  nextInstallmentAmountInCents,
}: {
  amountDueInCents: number;
  nextInstallmentAmountInCents?: number | null;
}): number =>
  typeof nextInstallmentAmountInCents === "number"
    ? nextInstallmentAmountInCents
    : amountDueInCents;

export const getPendingMemberPaymentActionState = ({
  canRecordManualPayment,
  canResendPaymentRequest,
  currentInvoiceId,
  paymentReceived,
}: {
  canRecordManualPayment: boolean;
  canResendPaymentRequest: boolean;
  currentInvoiceId?: string | null;
  paymentReceived: boolean;
}): PendingMemberPaymentActionState => {
  if (paymentReceived) {
    return {
      canApplyPayment: false,
      canSendPaymentRequest: false,
    };
  }

  return {
    canApplyPayment: canRecordManualPayment && !!currentInvoiceId,
    canSendPaymentRequest: canResendPaymentRequest,
  };
};
